import React from "react";
import { Dialog } from "primereact/dialog";
import styles from "./index.module.scss";
import Buttonc from "../button";
import { useCheckoutCount } from "../../../hooks/react-query/inv-exchange/useCheckoutCount";

export default function CheckoutConfirmDialog({
  Visible,
  setVisible,
  loading,
  onClick
}: {
  Visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  onClick: () => void;
}) {
  const { data } = useCheckoutCount(Visible);
  return (
    <Dialog
      dismissableMask={true}
      visible={Visible}
      closable={false}
      closeOnEscape={true}
      onHide={() => {
        setVisible(false);
      }}
      maskClassName={styles.checkoutConfirmDialogMask}
      className={styles.dialog}
      draggable={false}
      resizable={false}
    >
      <div className={styles.message}>Are you sure you want to Checkout?</div>
      <div className={styles.btnWrap}>
        <Buttonc
          btnType="border"
          type="submit"
          tabIndex={7}
          size="small"
          className={styles.cancelBtn}
          label={"Cancel"}
          disabled={loading}
          onClick={() => {
            setVisible(false);
          }}
        />
        <Buttonc
          type="submit"
          tabIndex={7}
          size="small"
          label={"Checkout"}
          loading={loading}
          onClick={onClick}
          className={styles.subBtn}
        />
      </div>
      <div className={styles.alertMessage}>
        {+data?.totCheckoutLimit - +data?.noOfCheckoutByUser} checkouts
        remaining. You can have a maximum of {data?.totCheckoutLimit} investors
        across all properties.
      </div>
    </Dialog>
  );
}
